import createSvgIcon from "./utils/create_icon"

const ChevronDownLarge = createSvgIcon(<path clipRule="evenodd" d="M3.293 7.293a1 1 0 0 0 0 1.414l8 8a1 1 0 0 0 1.414 0l8-8a1 1 0 0 0-1.414-1.414L12 14.586 4.707 7.293a1 1 0 0 0-1.414 0z" fill="currentColor" fillRule="evenodd" />, "ChevronDownLarge")
export default ChevronDownLarge
